import { CommercialCheckout } from './commercial-checkout';
import { PurchaseInformation } from './purchase-information';
import { SubscriptionManagement } from './subscription-management';

export type CheckoutFlow = CommercialCheckout | SubscriptionManagement | PurchaseInformation;
